import React from 'react'
import PropTypes from 'prop-types'
import { AdOrderContext } from '../../contexts/AdOrder'
import Label from './Label'
import InputWrap from './InputWrap'
import useInput from '../../hooks/useInput'

export default function Select ({
  name,
  label,
  labelExtraText,
  required = false,
  size,
  subobj = null,
  options = [],
  placeholder
}) {
  const { getValue, setValue } = useInput()

  const handleOnChange = function (e) {
    const value = e.target.value
    const processedValue = !isNaN(value) && value !== '' ? Number(value) : value
    setValue(name, processedValue, subobj)
  }

  return (
    <InputWrap size={size}>
      <Label htmlFor={name} required={required} extraText={labelExtraText}>{label}</Label>
      <select
        id={name}
        name={name}
        value={getValue(name, subobj) ?? ''}
        required={required}
        onChange={handleOnChange}
      >
        {placeholder && (
          <option value="" disabled hidden>
            {placeholder}
          </option>
        )}
        {options.map((opt, index) => (
          <option key={index} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </InputWrap>
  )
}

Select.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  labelExtraText: PropTypes.string,
  required: PropTypes.bool,
  size: PropTypes.oneOf(['half', 'third']),
  subobj: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      label: PropTypes.string.isRequired
    })
  ),
  placeholder: PropTypes.string
}
